import homes, { getServerSideProps } from './homes';
export default homes;
export { getServerSideProps };
